// extracted by mini-css-extract-plugin
module.exports = {"option":"styles_option__m6RvG","focussed":"styles_focussed__8MZIV","optionType":"styles_optionType__bUuIc","optionLogo":"styles_optionLogo__Rr_ep"};